import { useEffect } from "react";
import { IWeeklyReports } from "../../../../../models/dashboard/staffReports/staffReports";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { ReportFrequency } from "../../../../../models/dashboard/adminDashboard";
import { connect, useDispatch } from "react-redux";
import { setReportsMonthly } from "../../../../../store/slices/master/reportSlice";
import { getReports } from "../../../../../action/masters/reportActionCreator";
import { IReports } from "../../../../../models/master/reports";
import { baseURL } from "../../../../../constants/commonConstants";

const StaffWeeklyReportsViewAll = (props: IWeeklyReports) => {
  const { getWeeklyReports, weeklyReports } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getWeeklyReports(
      pageBlockId.reportResources,
      undefined,
      ReportFrequency.Monthly
    );
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setReportsMonthly([]));
    };
  }, []);

  return (
    <>
      <div className="widgets">
        <div className="title">
          <h2>All Weekly Reports</h2>
        </div>
        <div className="card-wrap">
          <div className="row">
            {weeklyReports?.map((report: IReports) => (
              <div className="report-all-card col-lg-12 mb-2" key={report.id}>
                <div className="card">
                  <div className="img">
                    <img src={baseURL + report.icon} alt="" />
                  </div>
                  <div className="desc">
                    <h3>{report.name}</h3>
                    <p>{report.description}</p>
                    <a
                      href={report.url}
                      target="_blank"
                      className="mt-3 btn-arrow btn-block-arrow"
                    >
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getWeeklyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    weeklyReports: state.report.monthlyreports,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffWeeklyReportsViewAll);
